import { __assign } from "tslib";
import base from './tooltip-base';
export default __assign({
  getDefaultCfg: function getDefaultCfg() {
    return {
      item: 'node',
      offset: 12,
      formatText: function formatText(model) {
        return model.label;
      }
    };
  },
  getEvents: function getEvents() {
    return {
      'node:mouseenter': 'onMouseEnter',
      'node:mouseleave': 'onMouseLeave',
      'node:mousemove': 'onMouseMove',
      afterremoveitem: 'onMouseLeave'
    };
  }
}, base);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-pc/es/behavior/tooltip.js
// module id = null
// module chunks = 